import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ar from './locales/ar.json';
import arz from './locales/arz.json';
import { DEFAULT_LOCALE, LOCALE_STORAGE_KEY } from './constants';
import { detectInitialLocale, resolveFallbackChain } from './fallback';

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  arz: { translation: arz },
};

let initialized = false;

export function initI18n() {
  if (initialized) return i18n;
  const lng = detectInitialLocale();

  i18n.use(initReactI18next).init({
    resources,
    lng,
    fallbackLng: (code) => resolveFallbackChain(code || DEFAULT_LOCALE),
    supportedLngs: ['en', 'arz'],
    nonExplicitSupportedLngs: true,
    load: 'currentOnly',
    interpolation: { escapeValue: false },
    returnEmptyString: false,
    returnNull: false,
    missingKeyHandler: false,
  });

  initialized = true;
  return i18n;
}

export async function persistLocale(locale) {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    /* private mode */
  }
}

export { i18n };
